import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Product from "./pages/Product";
import { getCountry, getProduct } from "./types/PartialProduct";
import ProductNotFound from "./pages/ProductNotFound";
import { getStoreData } from "./types/StoreData";
import Root from "./Root";
import ErrorBoundary from "./ErrorBoundary";
import Success from "./pages/Success";
import Failed from "./pages/Failed";
import Done from "./pages/Done";
import Pending from "./pages/Pending";
import Error from "./pages/Error";
import "./tailwind.css";

//import * as Sentry from "@sentry/react";
//Sentry.init({
//  dsn: "https://d4e180603f86049820dd8f24a923ead6@o4508391244365824.ingest.us.sentry.io/4508400973381632",
//  integrations: [Sentry.browserTracingIntegration()],
//  // Tracing
//  tracesSampleRate: 1.0, //  Capture 100% of the transactions
//  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//  tracePropagationTargets: ["localhost", /^https:\/\/damncheckout\.com\//],
//});

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    loader: async () => {
      const storeData = await getStoreData();
      const hasPostal = await getCountry();

      const data = {
        ...storeData,
        hasPostal: hasPostal,
      };

      return data;
    },
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/:id",
        element: <Product />,
        loader: async ({ params }) => {
          const product = await getProduct(params.id);

          return { product };
        },
        errorElement: <ProductNotFound />,
      },
      {
        path: "/success",
        element: <Success />,
      },
      {
        path: "/failed",
        element: <Failed />,
      },
      {
        path: "/done",
        element: <Done />,
      },
      {
        path: "/error",
        element: <Error />,
      },
      {
        path: "/pending",
        element: <Pending />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
